var exports = {
  "kL": "SimplePageSkeleton.module__container___eVJPVW",
  "wx": "SimplePageSkeleton.module__header___eVJPVW",
  "BU": "SimplePageSkeleton.module__headerCompact___eVJPVW",
  "Kh": "SimplePageSkeleton.module__headerLeading___eVJPVW",
  "$s": "SimplePageSkeleton.module__headerActions___eVJPVW",
  "Ge": "SimplePageSkeleton.module__rows___eVJPVW",
  "nM": "SimplePageSkeleton.module__row___eVJPVW",
  "pt": "SimplePageSkeleton.module__rowDetails___eVJPVW",
  "y6": "SimplePageSkeleton.module__channelGroups___eVJPVW",
  "Rf": "SimplePageSkeleton.module__channelGroupHeading___eVJPVW",
  "S7": "SimplePageSkeleton.module__channelCard___eVJPVW",
  "Fp": "SimplePageSkeleton.module__channelCardHeader___eVJPVW",
  "ut": "SimplePageSkeleton.module__channelCardStream___eVJPVW",
  "P9": "SimplePageSkeleton.module__channelCardFooter___eVJPVW",
  "YX": "SimplePageSkeleton.module__tableContent___eVJPVW",
  "KE": "SimplePageSkeleton.module__toolbar___eVJPVW",
  "d0": "SimplePageSkeleton.module__toolbarLeft___eVJPVW",
  "O5": "SimplePageSkeleton.module__toolbarRight___eVJPVW",
  "wY": "SimplePageSkeleton.module__tableWrapper___eVJPVW",
  "p": "SimplePageSkeleton.module__tableViewport___eVJPVW",
  "uV": "SimplePageSkeleton.module__tableSurface___eVJPVW",
  "QS": "SimplePageSkeleton.module__tableSurfaceSelectable___eVJPVW",
  "iA": "SimplePageSkeleton.module__tableFooter___eVJPVW",
  "vl": "SimplePageSkeleton.module__tableFooterLeft___eVJPVW",
  "C5": "SimplePageSkeleton.module__tableFooterRight___eVJPVW",
  "tT": "SimplePageSkeleton.module__tableHeadRow___eVJPVW",
  "ts": "SimplePageSkeleton.module__tableHeadCell___eVJPVW",
  "bg": "SimplePageSkeleton.module__tableBody___eVJPVW",
  "jD": "SimplePageSkeleton.module__tableRow___eVJPVW",
  "xR": "SimplePageSkeleton.module__tableCell___eVJPVW",
  "MN": "SimplePageSkeleton.module__tableNameCell___eVJPVW",
  "mg": "SimplePageSkeleton.module__tableNameInfo___eVJPVW",
  "Yo": "SimplePageSkeleton.module__tableActionsCell___eVJPVW",
};

module.exports = exports;
